import { z } from "zod/v4"

export const GetHomeDisplaySpacesRequest = z.object({
  kind: z.union([
    z.literal("spec-defined"),
    z.literal("all"),
    z.literal("dummy")
  ]).optional(),
  // TODO: clientが対応したら必須パラメータにする
  category: z.union([
    z.literal("recommend"),
    z.literal("follow"),
    z.literal("first-launch"),
  ]).optional(),
})

export type GetHomeDisplaySpacesRequest = z.infer<typeof GetHomeDisplaySpacesRequest>
